import { AddNameTuneDto } from '../../dto/addnametune/addnametunedto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';

export interface AddNameTuneRequest extends APIRequest
{
    getAddNameTuneRequest(): AddNameTuneDto;
}

export class AddNameTuneRequestImpl extends APIRequestDtoImpl implements AddNameTuneRequest
{
    constructor(private getAddNameTuneData: AddNameTuneDto)
    {
        super();
    }

    getAddNameTuneRequest(): AddNameTuneDto
    {
        return this.getAddNameTuneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/nametune/addnametunerequest.tsx